import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import autoBindMethods from 'class-autobind-decorator';

import { GuardedAnalyticsPageLink } from './PageLinks';
import { AppConstants } from '../../constants';
import { FunderStoreClass } from '../../stores';

const { ROUTING } = AppConstants;

interface IInjected {
  FunderStore: FunderStoreClass;
}

@inject('FunderStore')
@observer
@autoBindMethods
class CubeAnalyticsNav extends Component {
  get injected () {
    return this.props as IInjected;
  }

  public render () {
    const { FunderStore } = this.injected;

    if (!FunderStore.canUseCubeAnalytics) {
      return null;
    }

    return (
      <GuardedAnalyticsPageLink to={ROUTING.cubeAnalytics}>
        Analytics
      </GuardedAnalyticsPageLink>
    );
  }
}

export default CubeAnalyticsNav;
